

define(function () {

    var FIELD_SETS = { // eslint-disable-line no-reserved-keys
        'default': [],
        set1: ['dob', 'nationality'],
        set2: ['dob', 'nationality', 'marketing'],
        set3: ['address', 'dob', 'marketing'],
        set4: ['dob', 'nationality', 'occupation'],
        set5: ['dob', 'nationality', 'nationalId'],
        set6: ['dob', 'gender', 'placeOfBirth', 'nationality', 'nationalId']
    };

    var FIELDS = {
        US: FIELD_SETS['default'],
        IN: FIELD_SETS.set2,
        IL: FIELD_SETS.set5,
        AT: FIELD_SETS.set1,
        BE: FIELD_SETS.set1,
        DK: FIELD_SETS.set1,
        NO: FIELD_SETS.set1,
        PL: FIELD_SETS.set1,
        SE: FIELD_SETS.set1,
        AU: FIELD_SETS.set3,
        CA: FIELD_SETS.set4,
        SG: FIELD_SETS.set5,
        MY: FIELD_SETS.set2,
        KR: FIELD_SETS.set5,
        NZ: FIELD_SETS.set5,
        ID: FIELD_SETS.set5,
        TH: FIELD_SETS.set5,
        FR: FIELD_SETS.set1,
        DE: FIELD_SETS.set1,
        IT: FIELD_SETS.set1,
        ES: FIELD_SETS.set1,
        GB: FIELD_SETS.set1,
        NL: FIELD_SETS.set1,
        CH: FIELD_SETS.set5,
        TR: FIELD_SETS.set1,
        CZ: FIELD_SETS.set1,
        FI: FIELD_SETS.set1,
        EE: FIELD_SETS.set1,
        LV: FIELD_SETS.set1,
        HR: FIELD_SETS.set5,
        UA: FIELD_SETS.set1,
        PT: FIELD_SETS.set1,
        IE: FIELD_SETS.set1,
        HU: FIELD_SETS.set1,
        GR: FIELD_SETS.set1,
        SK: FIELD_SETS.set1,
        BA: FIELD_SETS.set1,
        BG: FIELD_SETS.set1,
        CY: FIELD_SETS.set1,
        HK: FIELD_SETS.set6,
        LT: FIELD_SETS.set1,
        LU: FIELD_SETS.set1,
        MT: FIELD_SETS.set1,
        PH: FIELD_SETS.set5,
        RO: FIELD_SETS.set1,
        SI: FIELD_SETS.set1,
        TW: FIELD_SETS.set1,
        AE: FIELD_SETS.set5,
        AL: FIELD_SETS.set1,
        AM: FIELD_SETS.set1,
        AZ: FIELD_SETS.set1,
        BH: FIELD_SETS.set5,
        BN: FIELD_SETS.set1,
        BY: FIELD_SETS.set1,
        EG: FIELD_SETS.set1,
        FO: FIELD_SETS.set5,
        GE: FIELD_SETS.set5,
        NG: FIELD_SETS.set1,
        OM: FIELD_SETS.set5,
        QA: FIELD_SETS.set5,
        RE: FIELD_SETS.set1,
        RS: FIELD_SETS.set5,
        SA: FIELD_SETS.set5,
        VA: FIELD_SETS.set1,
        ZA: FIELD_SETS.set5,
        ZM: FIELD_SETS.set1,
        LK: FIELD_SETS.set1,
        FM: FIELD_SETS.set1,
        MN: FIELD_SETS.set1,
        MV: FIELD_SETS.set1,
        VN: FIELD_SETS.set5,
        MK: FIELD_SETS.set1,
        GI: FIELD_SETS.set1,
        MQ: FIELD_SETS.set1,
        GP: FIELD_SETS.set1,
        MU: FIELD_SETS.set5,
        MD: FIELD_SETS.set5,
        IS: FIELD_SETS.set5,
        GL: FIELD_SETS.set5,
        KZ: FIELD_SETS.set5,
        KW: FIELD_SETS.set5,
        BT: FIELD_SETS.set1,
        KH: FIELD_SETS.set1,
        LA: FIELD_SETS.set1,
        NP: FIELD_SETS.set1,
        TO: FIELD_SETS.set1,
        WS: FIELD_SETS.set1,
        AO: FIELD_SETS.set1,
        BF: FIELD_SETS.set1,
        BI: FIELD_SETS.set1,
        BJ: FIELD_SETS.set1,
        CD: FIELD_SETS.set1,
        CG: FIELD_SETS.set1,
        CI: FIELD_SETS.set1,
        CK: FIELD_SETS.set1,
        CM: FIELD_SETS.set1,
        CV: FIELD_SETS.set1,
        DJ: FIELD_SETS.set1,
        ER: FIELD_SETS.set1,
        ET: FIELD_SETS.set1,
        FJ: FIELD_SETS.set1,
        GA: FIELD_SETS.set1,
        GF: FIELD_SETS.set1,
        GM: FIELD_SETS.set1,
        GN: FIELD_SETS.set1,
        GW: FIELD_SETS.set1,
        KG: FIELD_SETS.set1,
        KI: FIELD_SETS.set1,
        KM: FIELD_SETS.set1,
        LI: FIELD_SETS.set1,
        ME: FIELD_SETS.set1,
        MG: FIELD_SETS.set1,
        MH: FIELD_SETS.set1,
        ML: FIELD_SETS.set1,
        MR: FIELD_SETS.set1,
        MS: FIELD_SETS.set1,
        MW: FIELD_SETS.set1,
        NA: FIELD_SETS.set1,
        NC: FIELD_SETS.set1,
        NE: FIELD_SETS.set1,
        NF: FIELD_SETS.set1,
        NR: FIELD_SETS.set1,
        NU: FIELD_SETS.set1,
        PF: FIELD_SETS.set1,
        SZ: FIELD_SETS.set1,
        TD: FIELD_SETS.set1,
        TG: FIELD_SETS.set1,
        TJ: FIELD_SETS.set1,
        TM: FIELD_SETS.set1,
        TV: FIELD_SETS.set1,
        TZ: FIELD_SETS.set1,
        UG: FIELD_SETS.set5,
        VU: FIELD_SETS.set1,
        WF: FIELD_SETS.set1,
        YT: FIELD_SETS.set1,
        ZW: FIELD_SETS.set1,
        DZ: FIELD_SETS.set1,
        JO: FIELD_SETS.set5,
        MA: FIELD_SETS.set5,
        TN: FIELD_SETS.set1,
        YE: FIELD_SETS.set1,
        AD: FIELD_SETS.set5,
        BW: FIELD_SETS.set5,
        KE: FIELD_SETS.set5,
        LS: FIELD_SETS.set5,
        MC: FIELD_SETS.set5,
        MZ: FIELD_SETS.set5,
        SN: FIELD_SETS.set5,
        PG: FIELD_SETS.set1,
        PM: FIELD_SETS.set1,
        PN: FIELD_SETS.set1,
        PY: FIELD_SETS.set1,
        RW: FIELD_SETS.set1,
        SB: FIELD_SETS.set1,
        SC: FIELD_SETS.set1,
        SH: FIELD_SETS.set1,
        SJ: FIELD_SETS.set1,
        SL: FIELD_SETS.set1,
        SM: FIELD_SETS.set1,
        SO: FIELD_SETS.set1,
        ST: FIELD_SETS.set1,
        PW: FIELD_SETS.set1,
        AG: FIELD_SETS.set1,
        AN: FIELD_SETS.set1,
        AW: FIELD_SETS.set1,
        BB: FIELD_SETS.set1,
        BO: FIELD_SETS.set1,
        BZ: FIELD_SETS.set1,
        DM: FIELD_SETS.set1,
        FK: FIELD_SETS.set1,
        GD: FIELD_SETS.set1,
        GY: FIELD_SETS.set1,
        KN: FIELD_SETS.set1,
        LC: FIELD_SETS.set1,
        SR: FIELD_SETS.set1,
        TC: FIELD_SETS.set1,
        TT: FIELD_SETS.set1,
        VC: FIELD_SETS.set1,
        VG: FIELD_SETS.set1,
        AI: FIELD_SETS.set1,
        MX: FIELD_SETS.set1,
        AR: FIELD_SETS.set5,
        BM: FIELD_SETS.set5,
        BS: FIELD_SETS.set5,
        CL: FIELD_SETS.set5,
        CO: FIELD_SETS.set5,
        CR: FIELD_SETS.set5,
        DO: FIELD_SETS.set5,
        EC: FIELD_SETS.set5,
        GT: FIELD_SETS.set5,
        HN: FIELD_SETS.set5,
        JM: FIELD_SETS.set5,
        KY: FIELD_SETS.set5,
        NI: FIELD_SETS.set5,
        PA: FIELD_SETS.set5,
        PE: FIELD_SETS.set5,
        SV: FIELD_SETS.set5,
        UY: FIELD_SETS.set5,
        VE: FIELD_SETS.set5,
        C2: FIELD_SETS.set1
    };

    // converts ['a', 'b'] to {a:true, b:true}
    function arrayToObject(array) {
        var obj = {};

        array.map(function (key) {
            obj[key] = true;
        });

        return obj;
    }

    return {
        getSpecialFieldsFor: function getSpecialFieldsFor(country) {
            return arrayToObject(FIELDS[country] || FIELDS.US);
        },

        getFormattedAddress: function getFormattedAddress(address) {
            if (address.country === 'AU') {
                var AUStateCodeMap = {
                    australiancapitalterritory: 'ACT',
                    newsouthwales: 'NSW',
                    northernterritory: 'NT',
                    queensland: 'QLD',
                    southaustralia: 'SA',
                    tasmania: 'TAS',
                    victoria: 'VIC',
                    westernaustralia: 'WA'
                };

                address.state = AUStateCodeMap[address.state.replace(/\s/g, '').toLowerCase()] || address.state;
            }

            return address;
        },

        errorMapper: function errorMapper(errorData) {
            var errorMap = {
                DOB_INVALID: { field: '#dobText' },
                PHONE_INVALID: { field: '#telephone' },
                NATID_INVALID: { field: '#idValue' },
                FI_INVALID: { field: '#expiry_value, #cvv' },
                ADDRESS_LINEONE_INVALID: { field: '#billingLine1' },
                ADDRESS_CITY_INVALID: { field: '#billingCity' },
                ADDRESS_STATE_INVALID: { field: '#billingState' },
                ADDRESS_POSTAL_CODE_INVALID: { field: '#billingPostalCode' },
                PASSWORD_INVALID: { field: '#password, #confirmPassword' }
            };
            return errorMap[errorData].field;
        },

        pxpMapper: function pxpMapper($scope, $pxpMatch, preloadedData) {
            var patterns = {
                proxSignupTitleTreatment: 'prox_signup_title_treatment',
                proxSinglePasswordTreatment: 'prox_single_password_treatment'
            };
            var logPayload = {
                txn_id: preloadedData.transaction
            };

            if ($scope.locale.metadata.country === 'US') {
                $pxpMatch('prox_single_password', {}, patterns, logPayload).then(function (result) {
                    if (result && result.proxSinglePasswordTreatment) {
                        $scope.flags.singlePassword = true;
                    }
                });
            }
            if ($scope.locale.metadata.country === 'US' && $scope.locale.metadata.lang === 'en') {
                $pxpMatch('prox_signup_title', {}, patterns, logPayload).then(function (result) {
                    if (result && result.proxSignupTitleTreatment) {
                        $scope.pageTitle = $scope.locale.content.signup.eBayTitle;
                    } else {
                        $scope.pageTitle = $scope.locale.content.signup.title;
                    }
                });
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest-upgrade/lib/mapper.js
// module id = ./components/xo-guest-components/src/guest-upgrade/lib/mapper.js
// module chunks = 1